import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./index.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import ActivitySlider from "./components/ActivitySlider";
// import RunningVideoSection from "./components/RunningVideoSection";
// import ShapeYourMoodSection from "./components/futurefiles/ShapeYourMoodSection";
// import FitnessPathGame from "./components/futurefiles/FitnessPathGame";
import ActivityInvitePage from "./components/ActivityInvitePage";


import About from "./components/About";
import Footer from "./components/footer";
import JoinModal from "./components/button";
// import Team from "./components/Team";
import WhatIsBFF from "./components/WhatIsBFF";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfService from "./components/TermsOfService";
import Contact from "./components/Contact";
import DeleteAccount from "./components/DeleteAccount";
import Unsubscribe from "./components/UnsubscribeEmails";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}


function HomePage({ onJoin, open, onCloseJoin }) {
  return (
    <>
      <Navbar onJoin={onJoin} />
      <Hero onJoin={onJoin} />
      <ActivitySlider />
      <About />
      <WhatIsBFF />
      {/* <FitnessPathGame /> */}
      {/* <Team /> */}
      {/* <RunningVideoSection /> */}
      {/* <ShapeYourMoodSection /> */}
      

      {/* 🔵 Footer can open modal too */}
      <Footer onJoin={onJoin} />
    </>
  );
}

function ContactPage({ onJoin }) {
  return (
    <>
      <Navbar onJoin={onJoin} />
      <Contact />
      <Footer onJoin={onJoin} />
    </>
  );
}


export default function App() {
  const [open, setOpen] = useState(false);

  const handleOpenJoin = () => setOpen(true);
  const handleCloseJoin = () => setOpen(false);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          path="/contact"
          element={<ContactPage onJoin={handleOpenJoin} />}
        />
        <Route
          path="/activityinvite"
          element={<ActivityInvitePage />}
        />
        <Route
          path="/activityinvite/:activityId"
          element={<ActivityInvitePage />}
        />
        {/* Dynamic Activity Route */}
        <Route 
          path="/activity/:activityId" 
          element={<ActivityInvitePage />} 
        />
        <Route
          path="/privacy"
          element={<PrivacyPolicy />}
        />
        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy />}
        />
        <Route
          path="/terms"
          element={<TermsOfService />}
        />
        <Route
          path="/terms-of-service"
          element={<TermsOfService />}
        />
        <Route
          path="/delete-account"
          element={<DeleteAccount />}
        />
        <Route
          path="/unsubscribe"
          element={<Unsubscribe />}
        />
        <Route
          path="*"
          element={
            <HomePage
              onJoin={handleOpenJoin}
              open={open}
              onCloseJoin={handleCloseJoin}
            />
          }
        />
      </Routes>
      <JoinModal open={open} onClose={handleCloseJoin} />
    </>
  );
}